import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="app-container" style={{ padding: "2rem" }}>
      <Link to="/" className="privacy-back-btn">
        ← Ana Sayfaya Dön
      </Link>
      
      <div className="privacy-container">
        <h1>Gizlilik Politikası</h1>
        <p className="last-updated">Son Güncelleme: 30 Haziran 2026</p>

        <p>
          Bu Gizlilik Politikası, Hizmeti kullandığınızda bilgilerinizin toplanması, 
          kullanılması ve ifşa edilmesine ilişkin politika ve prosedürlerimizi açıklar, 
          gizlilik haklarınızı ve yasaların sizi nasıl koruduğunu anlatır.
        </p>
        <p>
          Kişisel verilerinizi Hizmeti sağlamak ve geliştirmek için kullanırız. 
          Hizmeti kullanarak, bilgilerin bu Gizlilik Politikasına uygun olarak toplanmasını 
          ve kullanılmasını kabul etmiş olursunuz.
        </p>

        <hr />
        
        <h2>Tanımlar</h2>
        <ul>
          <li><strong>Hesap:</strong> Hizmetimize veya Hizmetimizin bölümlerine erişmeniz için oluşturulan benzersiz bir hesap.</li>
          <li><strong>Uygulama:</strong> Kabadayı Games altında Resul Çalışkan tarafından geliştirilen <em>Ballgorithm</em> mobil oyununu ifade eder.</li>
          <li><strong>Şirket:</strong> Bu sözleşmede &quot;Kabadayı Games&quot;, &quot;biz&quot;, &quot;bize&quot; veya &quot;bizim&quot; olarak anılacaktır.</li>
          <li><strong>Ülke:</strong> Türkiye.</li>
          <li><strong>Cihaz:</strong> Akıllı telefon veya tablet gibi Hizmete erişebilen herhangi bir cihaz.</li>
          <li><strong>Kişisel Veri:</strong> Kimliği belirli veya belirlenebilir bir kişiye ilişkin her türlü bilgi.</li>
          <li><strong>Hizmet Providers (Hizmet Sağlayıcılar):</strong> Hizmeti sunmamıza yardımcı olan üçüncü taraf satıcılar.</li>
          <li><strong>Kullanım Verileri:</strong> IP adresi, cihaz türü, işletim sistemi sürümü vb. gibi otomatik olarak toplanan veriler.</li>
        </ul>

        <hr />

        <h2>Kişisel Verilerin Toplanması ve Kullanılması</h2>
        <h3>Toplanan Veri Türleri</h3>
        <p><strong>Kişisel Veriler</strong></p>
        <p>Sizden aşağıdaki gibi bazı bilgileri talep edebiliriz:</p>
        <ul>
          <li>E-posta adresi</li>
        </ul>

        <p><strong>Kullanım Verileri</strong></p>
        <p>Hizmeti kullandığınızda otomatik olarak toplanır ve şunları içerebilir:</p>
        <ul>
          <li>Cihazınızın IP adresi</li>
          <li>Cihaz türü ve ID'si</li>
          <li>İşletim sistemi</li>
          <li>Uygulama kullanım detayları (sayfa görüntülemeleri, süre vb.)</li>
        </ul>

        <hr />

        <h2>Kişisel Verilerinizin Kullanımı</h2>
        <p>Verilerinizi şu amaçlarla işleyebiliriz:</p>
        <ul>
          <li>Hizmeti sağlamak, sürdürmek ve geliştirmek</li>
          <li>Hesabınızı yönetmek</li>
          <li>E-posta veya uygulama içi bildirimler yoluyla sizinle iletişim kurmak</li>
          <li>Güncellemeler veya haberler sunmak</li>
          <li>Hukuki yükümlülüklere uymak</li>
        </ul>

        <hr />

        <h2>Reklamcılık ve Üçüncü Taraf Hizmetleri</h2>
        <p>
          Uygulamamız reklam göstermek amacıyla <strong>Google AdMob</strong> kullanabilir. 
          AdMob, reklamları kişiselleştirmek ve reklam performansını artırmak amacıyla cihaz türünüz, 
          reklam kimliğiniz, IP adresiniz, konumunuz ve reklamlarla olan etkileşiminiz gibi bilgileri toplayabilir.
        </p>
        <p>Daha fazla bilgi için:</p>
        <ul>
          <li>
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
              Google Gizlilik Politikası
            </a>
          </li>
          <li>
            <a href="https://support.google.com/admob/answer/6128543?hl=tr" target="_blank" rel="noopener noreferrer">
              Google AdMob Politikası
            </a>
          </li>
        </ul>

        <hr />

        <h2>Verilerin Silinmesi ve İletişim</h2>
        <p>
          Topladığımız verileri silmemizi talep etmek, sorularınızı iletmek veya gizlilik haklarınız hakkında bilgi 
          almak için bizimle dilediğiniz zaman iletişime geçebilirsiniz:
        </p>
        <ul>
          <li>📧 <strong>resulcaliskansau@gmail.com</strong></li>
          <li>👤 <strong>Geliştirici</strong>: Resul Çalışkan</li>
          <li>🎮 <strong>Oyun</strong>: Ballgorithm</li>
          <li>🏢 <strong>Şirket</strong>: Kabadayı Games</li>
        </ul>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
